import { LP_STATUS } from "@utils/constants/learningPath";

export const DEFAULT_LANG = "English";

export const getLanguageLabel = (lang?: string) => {
  return lang || DEFAULT_LANG;
}

export const decodeBase64 = (value?: string) => {
  if (!value) return 'No description available';
  try {
    return atob(value);
  } catch {
    return value;
  }
};

export const getSelectedPackage = (unit: any) => unit?.packages?.[0] ?? {};

export const getUnitContent = (unit: any) => {
  const pkg = getSelectedPackage(unit);
  return {
    title: pkg?.name || "No title available",
    description: decodeBase64(pkg?.description),
    startUrl: pkg?.url,
    redoUrl: pkg?.redo,
  };
};

export const openInNewTab = (url?: string) => {
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};

export const getUnitStatus = (packages: any[] = []): string => {
  if (!packages.length) return LP_STATUS.NOT_YET_STARTED;
  if (packages.every((p) => p.status === "complete")) {
    return LP_STATUS.COMPLETE;
  }
  if (packages.some((p) => p.status === "in_progress")) {
    return LP_STATUS.IN_PROGRESS;
  }
  return LP_STATUS.NOT_YET_STARTED;
};

export const langToLocaleMap: Record<string, string> = {
  English: "English",
  German: "German",
  Spanish: "Spanish",
  French: "French",
  Polish: "Polish"
};

export const languageOptions = Object.values(langToLocaleMap).map((lang) => ({
  key: lang,
  label: lang,
  value: lang,
}));

export const hasPublishedScormUnits = (LearningPaths: any) => {
  return LearningPaths?.learningPaths?.some((lp: any) =>
    lp?.details?.units?.some(
      (unit: any) =>
        unit?.unittype === 'scorm' &&
        (unit?.packages || []).some((pkg: any) => pkg?.published)
    )
  )
}

export const hasPublishedScormPackage = (unit: any): boolean => {
  return (unit?.packages || []).some((pkg: any) => pkg?.published)
}

export const getIdsFromRedoUrl = (url: string) => {
  try {
    const parsed = new URL(url);
    return {
      userId: Number(parsed.searchParams.get('userId')),
      scormId: Number(parsed.searchParams.get('scormId')),
    };
  } catch {
    return { userId: null, scormId: null };
  }
};
